import React, { useMemo } from 'react';
import { useIntl, getLocale } from 'umi';
import MultipleSelector, { MulSelectorProps, SelectOptionWithGroup, renderImgText } from './MultipleSelector';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { LANGUAGE_CN } from '@/pages/intelligence/_config/config';

import './index.scss';

interface ICountrySelectorProps extends MulSelectorProps {
  title?: string;
  options: {
    value: string;
    textEN: string;
    textCN: string;
    icon: string;
  }[];
  value: string[];
  onConfirm: (payload: string[]) => void;
}

export default function CountrySelector(props: ICountrySelectorProps) {
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { title = 'dbi_countries', options: optionsOuter, value: valueOuter, onConfirm, disabled } = props;

  const options = useMemo<SelectOptionWithGroup[]>(() => {
    if (!Array.isArray(optionsOuter)) return [];
    return optionsOuter.map((item) => {
      const { value, textEN, textCN, icon } = item ?? {};
      const text = (locale === LANGUAGE_CN ? textCN : textEN) || textEN;
      const iconImg = getCountryFlag(icon);
      return {
        value: value ?? '',
        text: renderImgText(text, iconImg),
        label: text ?? '',
      };
    });
  }, [locale, optionsOuter]);

  const value = Array.isArray(valueOuter) ? valueOuter : [];

  return (
    <MultipleSelector
      hasAllCheck
      className="dbi-common-country-select"
      buttonName={formatMessage({ id: title || 'dbi_countries' })}
      options={options}
      value={value}
      onChange={onConfirm}
      searchable={true}
      filter={(value: string, item: any) => {
        const REG = new RegExp(value || '', 'gi'); // 模糊匹配正则
        return REG.test(item?.label);
      }}
    />
  );
}
